<template>
	<div
		id="data-list-list-view"
		class="data-list-container"
	>
		<vs-popup
			class="holamundo"
			:title="modalType == 'edit' ? 'Megrendelő módosítása' : 'Új megrendelő'"
			:active.sync="customerModal"
		>
			<form
				data-vv-scope="customer"
				v-on:submit.prevent
			>
				<div class="vs-row">
					<vs-row>
						<vs-col
							vs-justify="left"
							vs-align="left"
							vs-w="6"
							class="p-2"
						>
							<vs-input
								label-placeholder="Név"
								v-model="customer.name"
								class="w-full mt-4"
								name="name"
								v-validate="'required'"
								v-on:keyup.enter="validate"
							/>
							<span class="text-danger">{{ errors.first('customer.name') }}</span>
						</vs-col>
						<vs-col
							vs-justify="left"
							vs-align="left"
							vs-w="6"
							class="p-2"
						>
							<vs-input
								label-placeholder="Adószám"
								v-model="customer.vatNumber"
								class="w-full mt-4"
								name="name"
								v-on:keyup.enter="validate"
							/>
						</vs-col>
					</vs-row>
					<vs-row>
						<vs-col
							vs-justify="left"
							vs-align="left"
							vs-w="6"
							class="p-2"
						>
							<vs-input
								label-placeholder="Vezetéknév"
								v-model="customer.firstName"
								class="w-full mt-4"
								name="firstName"
								v-on:keyup.enter="validate"
							/>
						</vs-col>
						<vs-col
							vs-justify="left"
							vs-align="left"
							vs-w="6"
							class="p-2"
						>
							<vs-input
								label-placeholder="Keresztnév"
								v-model="customer.lastName"
								class="w-full mt-4"
								name="lastName"
								v-on:keyup.enter="validate"
							/>
						</vs-col>
					</vs-row>
					<vs-row>
						<vs-col
							vs-justify="left"
							vs-align="left"
							vs-w="6"
							class="p-2"
						>
							<vs-input
								label-placeholder="E-mail cím"
								v-model="customer.email"
								class="w-full mt-4"
								name="email"
								v-on:keyup.enter="validate"
							/>
						</vs-col>
						<vs-col
							vs-justify="left"
							vs-align="left"
							vs-w="6"
							class="p-2"
						>
							<vs-input
								label-placeholder="Telefonszám"
								v-model="customer.phone"
								class="w-full mt-4"
								name="phone"
								v-on:keyup.enter="validate"
							/>
						</vs-col>
					</vs-row>
					<vs-row>
						<vs-col
							vs-justify="left"
							vs-align="left"
							vs-w="4"
							class="p-2"
						>
							<vs-input
								label-placeholder="Irányítószám"
								v-model="customer.zipCode"
								class="w-full mt-4"
								name="zipCode"
								v-on:keyup.enter="validate"
								@change="getCity"
							/>
						</vs-col>
						<vs-col
							vs-justify="left"
							vs-align="left"
							vs-w="8"
							class="p-2"
						>
							<vs-input
								label-placeholder="Város"
								v-model="customer.city"
								class="w-full mt-4"
								name="city"
								v-on:keyup.enter="validate"
							/>
						</vs-col>

					</vs-row>
					<vs-row>
						<vs-col
							vs-justify="left"
							vs-align="left"
							vs-w="4"
							class="p-2"
						>
							<vs-input
								label-placeholder="Utca"
								v-model="customer.street"
								class="w-full mt-4"
								name="street"
								v-on:keyup.enter="validate"
							/>
						</vs-col>
						<vs-col
							vs-justify="left"
							vs-align="left"
							vs-w="4"
							class="p-2"
						>
							<vs-input
								label-placeholder="Utcatípus"
								v-model="customer.streetType"
								class="w-full mt-4"
								name="street_type"
								v-on:keyup.enter="validate"
							/>
						</vs-col>
						<vs-col
							vs-justify="left"
							vs-align="left"
							vs-w="4"
							class="p-2"
						>
							<vs-input
								label-placeholder="Házszám"
								v-model="customer.houseNumber"
								class="w-full mt-4"
								name="house_number"
								v-on:keyup.enter="validate"
							/>
						</vs-col>

					</vs-row>
					<vs-row>
						<vs-col
							vs-justify="left"
							vs-align="left"
							vs-w="12"
							class="p-2"
						>
							<vs-select
								class="w-full"
								label="Szülő"
								v-model="customer.parentId"
							>
								<vs-select-item
									v-for="customer in customers"
									:key="customer.id"
									:value="customer.id"
									:text="customer.name"
								/>
							</vs-select>
						</vs-col>

					</vs-row>

					<vs-row>
						<vs-col
							vs-w="6"
							class="p-2"
						>
							<vs-button
								class="mr-3 mb-2"
								@click="validate()"
							>Mentés</vs-button>
						</vs-col>
					</vs-row>
				</div>
			</form>
		</vs-popup>
		<div
			id="loading-bg"
			v-if="loading"
		>
			<div class="loading">
				<div class="effect-1 effects"></div>
				<div class="effect-2 effects"></div>
				<div class="effect-3 effects"></div>
			</div>
		</div>
		<vx-card>
			<div class="flex">
				<vs-button
					color="primary"
					size="large"
					type="flat"
					icon="icon-arrow-left"
					icon-pack="feather"
					@click="$router.go(-1)"
				></vs-button>
				<h4 class="mt-3">
					Megrendelők
				</h4>
				<div class="rounded-lg cursor-pointer items-center justify-center right-button">
					<vs-button
						color="primary"
						size="medium"
						class="pull-right btn-add-new"
						type="filled"
						icon-pack="feather"
						icon="icon-plus"
						@click="addNewData"
					>
						Új megrendelő
					</vs-button>
				</div>
			</div>
			<vs-table
				v-model="selected"
				@selected="editData(selected)"
				v-if="customers"
				pagination
				:hoverFlat="true"
				:notSpacer="true"
				:data="customers"
				noDataText="Nincs találat"
				maxItems="10"
				search
			>

				<div
					slot="header"
					class="flex flex-wrap-reverse items-center flex-grow justify-between mb-6"
				>
					<div class="flex flex-wrap-reverse items-center data-list-btn-container">
						<!-- Input search -->
					</div>
				</div>

				<template slot="thead">
					<vs-th sort-key="displayName">Név</vs-th>
					<vs-th sort-key="fullAddress">Cím</vs-th>
					<vs-th sort-key="email">E-mail</vs-th>
					<vs-th sort-key="phone">Telefonszám</vs-th>
					<vs-th sort-key="phone">Utolsó sorszám (lakossági)</vs-th>
					<vs-th sort-key="phone">Utolsó sorszám (Vállalati)</vs-th>
					<vs-th sort-key="phone">Leadási határidő (nap)</vs-th>
					<vs-th></vs-th>
				</template>

				<template slot-scope="{data}">
					<tbody>
						<vs-tr
							:data="customer"
							:key="index"
							v-for="(customer, index) in data"
						>

							<vs-td :data="customer.displayName">
								<p class="product-name font-medium truncate">{{ customer.displayName }}</p>
							</vs-td>

							<vs-td :data="customer.fullAddress">
								<p class="product-category">{{ customer.fullAddress }}</p>
							</vs-td>

							<vs-td :data="customer.email">
								<p class="product-category">{{ customer.email }}</p>
							</vs-td>

							<vs-td :data="customer.phone">
								<p class="product-category">{{ customer.phone }}</p>
							</vs-td>

							<vs-td :data="customer.lastResidentalPhomeId">
								<p class="product-category">{{ customer.lastResidentalPhomeId }}</p>
							</vs-td>

							<vs-td :data="customer.lastCompanyPhomeId">
								<p class="product-category">{{ customer.lastCompanyPhomeId }}</p>
							</vs-td>
							
							<vs-td :data="customer.dueDays">
								<p class="product-category">{{ customer.dueDays }}</p>
							</vs-td>

							<vs-td class="whitespace-no-wrap">
								<div class="flex pull-right">
									<vx-tooltip text="Módosítás">
										<vs-button
											type="border"
											size="medium"
											icon-pack="feather"
											icon="icon-edit"
											class="mr-2"
											color="dark"
											@click.stop="editData(customer)"
										></vs-button>
									</vx-tooltip>
									<vx-tooltip text="Törlés">
										<vs-button
											type="border"
											size="medium"
											icon-pack="feather"
											icon="icon-trash-2"
											color="danger"
											class="mr-2"
											@click="deleteData(customer.id)"
										></vs-button>
									</vx-tooltip>
								</div>
							</vs-td>
						</vs-tr>
					</tbody>
				</template>
			</vs-table>
		</vx-card>
	</div>
</template>

<script>
import { Validator } from 'vee-validate';

const dict = {
	custom: {
		firstName: {
			required: 'Vezetéknév megadása kötelező.',
		},
		lastName: {
			required: 'Keresztnév megadása kötelező.',
		},
	}
};
Validator.localize('en', dict);
export default {

	// register custom messages
	components: {
	},
	data() {
		return {
			modalType: '',
			customers: null,
			selected: null,
			itemsPerPage: 10,
			isMounted: false,
			loading: true,
			customerModal: false,
			customer: {
				firstName: '',
				lastName: ''
			}
		}
	},
	computed: {
		currentPage() {
			if (this.isMounted) {
				return this.$refs.table.currentx
			}
			return 0
		}
	},
	watch: {
	},
	methods: {
		fetch() {
			this.$http.get("/api/customers/list/")
				.then((response) => {
					this.customers = response.data.data
					this.loading = false
				})
				.catch((error) => { console.log(error) })
		},
		addNewData() {
			this.$router.push('/megrendelok/uj')
		},
		deleteData(id) {
			event.stopPropagation();
			this.$vs.dialog({
				type: 'confirm',
				color: 'danger',
				title: `Biztosan törlöd az adatot?`,
				acceptText: 'IGEN, törlöm',
				cancelText: 'mégsem',
				text: '',
				accept: this.confirmDelete,
				parameters: id
			})
		},
		confirmDelete(id) {
			event.stopPropagation();
			this.$http.delete("/api/customers/delete/" + id)
				.then(() => {
					this.$vs.notify({
						title: 'Siker',
						text: 'Sikeres törlés',
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'success',
						position: 'bottom-center'
					})
					this.fetch();
				})
				.catch((error) => { console.log(error) })
		},
		editData(customer) {
			this.$router.push('/megrendelo/' + customer.id)
			// this.modalType = 'edit'
			// this.customer = customer
			// this.customerModal = true
		},
		validate() {
			return new Promise((resolve, reject) => {
				this.$validator.validateAll("customer").then(result => {
					if (result) {
						this.save()
						resolve(true)
					} else {
						reject("correct all values");
					}
				})
			})


		},
		save() {
			var postMethod = 'create'
			switch (this.modalType) {
				case 'create':
					postMethod = 'create'
					break;

				case 'edit':
					postMethod = 'update/' + this.customer.id
					break;

				default:
					this.$vs.notify({
						title: 'Hiba',
						text: 'Ismeretlen metódus',
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'danger',
						position: 'bottom-center'
					})
					break;
			}

			this.$http.post("/api/customers/" + postMethod, this.customer)
				.then(() => {
					this.fetch();
					this.customer = {}
					this.customerModal = false
					this.$vs.notify({
						title: 'Siker',
						text: 'Sikeres mentés',
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'success',
						position: 'bottom-center'
					})
				})
		},
		getCity() {
			this.$http.post('/api/transactions/getCity', { zipCode: this.customer.zipCode })
				.then((response) => {
					this.customer.city = response.data.city
					console.log(this.customer);
				})
				.catch((error) => { console.log(error) })
		}
	},
	created() {
		this.fetch()
	},
	mounted() {
		this.isMounted = true;
	}
}
</script>

<style lang="scss">
#data-list-list-view {
	.vs-con-table {
		/*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 0rem;
			margin-right: 0rem;
			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			border-collapse: separate;
			border-spacing: 0rem;

			tr {
				box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
				td {
					padding: 20px;
				}
				td.td-check {
					padding: 20px !important;
				}
			}
		}

		.vs-table--thead {
			th {
				background-color: #fff;
				padding-top: 10;
				padding-bottom: 10;

				.vs-table-text {
					text-transform: uppercase;
					font-weight: 600;
				}
			}
			th.td-check {
				padding: 0 15px !important;
			}
			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}
</style>
